__webpack_require__.p = "/app/themes/luxury-restaurant-guide/dist/";